<!-- 理光实物审批 -->
<template>
	<div class="process-page">
		<!-- 机器零件信息 -->
		<div class="create-section">
			<div class="mb20" v-if="faultyExpress != null">
				<el-button type="primary" @click="handleCheckExpress">查看实物寄件信息</el-button>
			</div>
			<h3>{{ partTitleObj[repairType] }}信息</h3>
			<!-- 动态生成的零件信息部分 -->
			<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
				<div class="flex-1">
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}名称</p>
							<p class="content">{{ part.partsName }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}编号</p>
							<p class="content">{{ part.partsNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">申请数量</p>
							<p class="content">{{ part.partsAmount }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
					</div>
					<div class="part-info-item" v-if="part.partsBatchNumber != null">
						<div class="info-box">
							<p class="title">批号</p>
							<p class="content">{{ part.partsBatchNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
					</div>
				</div>
				<div class="flex-1 part-info-box-right">
					<div class="right-item">
						测试结果：
						<el-radio v-model="part.partsTest" label="2">故障</el-radio>
						<el-radio v-model="part.partsTest" label="1">正常</el-radio>
					</div>
				</div>
			</div>
			<div class="process-item">
				<p>附件</p>
				<el-upload
					:action="action"
					:headers="headers"
					:multiple="true"
					:show-file-list="false"
					:before-upload="handleBeforeUpload"
					:on-error="handleError"
					:on-success="(res, file, list) => handleSuccess('report', res, file, list)">
					<el-button icon="el-icon-paperclip">上传文件</el-button>
				</el-upload>
				<FileList :file-list="testFileIdList" :list-name="'report'" closable @onRemove="handleAttachFileRemove" class="mt4"></FileList>
			</div>
			<div class="process-item" v-if="faultyExpress != null">
				<p>请根据物流情况填写索赔件实际到货时间</p>
				<el-date-picker
					v-model="partsClaimOrders.receivedTime"
					type="datetime"
					format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
					:picker-options="pickerOptions"
					placeholder="请选择日期时间"></el-date-picker>
			</div>
			<div class="process-item">
				<p>审批批注</p>
				<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="auditRemarks"></el-input>
			</div>
			<div class="create-footer">
				<el-button type="primary" @click="handleSubmit()">提交</el-button>
			</div>
		</div>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<!-- 流程信息 -->
		<CommonCollapse2 />
	</div>
</template>
<script>
import { claimOrdersInfo, testSubmit } from "@/api/claim";
const defaultSettings = require("@/settings.js");
const hostName = defaultSettings.hostName;
import FileList from "../components/FileList.vue";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import CommonCollapse2 from "../components/CommonCollapse2.vue";
import { debounce } from "@/utils/debounce";
export default {
	components: {
		FileList,
		ShowAddressInfo,
		CommonCollapse2,
	},
	data() {
		return {
			mainId: "",
			repairType: "",
			auditOrgName: "",
			partsDetailList: [],
			createTime: "",
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			// 审批批注
			auditRemarks: "",
			// 查看实物寄件信息
			faultyExpress: null,
			partsClaimOrders: {
				id: "",
				testFileIdList: [],
				receivedTime: "",
			},
			testFileIdList: [],
			innerAdvanceCode: "",
			applyAdvanceCode: "",
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期（只能选今天及之前）
					return time.getTime() > Date.now();
				},
			},
		};
	},
	computed: {
		action() {
			return hostName + "bsi/sysAttachFile/addFileOss";
		},
		headers() {
			const token = sessionStorage.getItem("token") || "";
			return {
				token: token,
			};
		},
		// 是否是超级管理员
		isSuperAdmin() {
			const userInfoStr = window.sessionStorage.getItem("userInfo");
			if (!userInfoStr) return false;
			const userInfo = JSON.parse(userInfoStr);
			if (!userInfo) return false;
			if (userInfo.superAdminFlag === "1") return true;
			return false;
		},
	},
	mounted() {
		this.getClaimWarrantyInfo();
	},
	methods: {
		// 获取单个索赔信息
		getClaimWarrantyInfo() {
			// 获取单个索赔信息
			const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
			let self = this;
			claimOrdersInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.mainId = r.data.id;
						// r.data.currentAudit.remark == null ? (self.auditRemarks = "") : (self.auditRemarks = r.data.currentAudit.remark);
						self.faultyExpress = r.data.partsClaimOrders.faultyExpress;
						self.repairType = r.data.repairType;
						self.auditOrgName = r.data.auditOrgName;
						self.createTime = r.data.currentAudit.createTime;
						// partsClaimOrders
						self.partsClaimOrders.id = r.data.partsClaimOrders.id;
						r.data.partsClaimOrders.receivedTime == null ? "" : (self.partsClaimOrders.receivedTime = r.data.partsClaimOrders.receivedTime);
						// partsDetailList
						// 方法1：使用 Vue.set 或 this.$set（Vue 2）
						for (const element of r.data.partsDetailList) {
							element.partsTest = "";
						}
						self.partsDetailList = [...r.data.partsDetailList];
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 提交
		handleSubmit: debounce(function () {
			this.updateWarranty();
		}, 1000),
		// 提交接口
		updateWarranty() {
			let self = this;
			const params = {
				id: self.mainId,
				auditRemarks: self.auditRemarks,
			};
			let partsDetailList = [];
			let flag1 = false;
			for (const element of self.partsDetailList) {
				let obj = {
					id: element.id,
					partsTest: element.partsTest,
				};
				partsDetailList.push(obj);
				if (element.partsTest == "") {
					flag1 = true;
				}
			}
			if (flag1) {
				self.$message.error(`请填写所有零件的测试结果`);
				return;
			}
			if (self.testFileIdList.length == 0) {
				self.$message.error(`请上传附件`);
				return;
			}
			if (self.partsClaimOrders.receivedTime == "" && self.faultyExpress != null) {
				self.$message.error(`请选择索赔件实际到货时间`);
				return;
			}
			if (self.partsClaimOrders.receivedTime < self.createTime && self.faultyExpress != null) {
				self.$message.error(`索赔件实际到货时间请大于故障件发货的时间${self.createTime}`);
				return;
			}
			if (self.auditRemarks == "") {
				self.$message.error(`请输入审批批注`);
				return;
			}
			let testFileIdList = [];
			if (self.testFileIdList.length > 0) {
				for (const file of self.testFileIdList) {
					testFileIdList.push(file.id);
				}
			}
			self.partsClaimOrders.testFileIdList = testFileIdList;
			params.partsClaimOrders = self.partsClaimOrders;
			params.partsDetailList = partsDetailList;
			testSubmit(params, true)
				.then((r) => {
					if (r.code == "0") {
						self.$message({
							message: "操作成功",
							type: "success",
						});
						self.$router.push({
							name: "claimReviewList",
						});
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 上传前校验
		handleBeforeUpload(file) {
			if (this.isSuperAdmin) {
				// 超管单个文件大小限制1G
				const limitSize = file.size / 1024 / 1024 / 1024 <= 1;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过1G");
					return false;
				}
			} else {
				// 非超管单个文件大小限制255M
				// 2022-07-31 应客户要求改为200M
				const limitSize = file.size / 1024 / 1024 <= 200;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过200M");
					return false;
				}
			}
		},
		// 上传失败回调
		handleError(err, file, fileList) {
			console.log(`handleError`);
			console.log(err);
		},
		// 上传成功回调
		handleSuccess(index, response, file, fileList) {
			console.log(`handleSuccess`);
			if (index == "report") {
				this.testFileIdList.push(file.response.data);
			} else {
				this.partsDetailList[index].fileList.push(file.response.data);
			}
		},
		// 删除上传文件
		handleAttachFileRemove(file, listName) {
			console.log(file);
			const index = listName;
			if (index == "report") {
				let array = [];
				for (const element of this.testFileIdList) {
					if (element.id != file.id) {
						array.push(element);
					}
				}
				this.testFileIdList = [...array];
			} else {
				let array = [];
				for (const element of this.partsDetailList[index].fileList) {
					if (element.id != file.id) {
						array.push(element);
					}
				}
				this.$set(this.partsDetailList[index], "fileList", [...array]);
			}
		},
		// 点击查看实物寄件信息
		handleCheckExpress() {
			this.$refs.showAddressInfo.init(this.faultyExpress);
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}
.create-section {
	border-top: 1px solid #ddd;
	padding-top: 20px;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
	min-width: 0;
	word-wrap: break-word;
}
h3 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
	}
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
	.el-select {
		width: 100%;
	}
}
.t-r {
	text-align: right;
}
.mt10 {
	margin-top: 10px;
}
.mb20 {
	margin-bottom: 20px;
}
.report-book-box {
	margin-top: 20px;
	h2 {
		margin-bottom: 10px;
	}
	.title1 {
		font-size: 14px;
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		margin-top: 5px;
		margin-bottom: 10px;
	}
}
.tips {
	font-size: 13px;
	color: #909399;
}
</style>
